import { useState } from "react";
import { clubApi } from "../api/club.service";
import { ClubMassPayload } from "../types";

export interface FailedRowType {
  row: number;
  data: {
    club_name_vie: string;
    club_name_eng: string;
    key: string;
  };
  error: string;
}

export const useCreateMass = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const mutation = async (payload: ClubMassPayload[]) => {
    try {
      setLoading(true);

      const response: any = await clubApi.createMass(payload);

      return {
        success: true,
        message: response?.data?.message,
        total_success: response?.data?.data?.total_success,
        total_failed: response?.data?.data?.total_failed,
        failed_rows: response?.data?.data?.failed_rows as FailedRowType[],
      };
    } catch (err: any) {
      console.error("Create club mass failed:", err);

      return {
        success: false,
        message: err?.response?.data?.error?.message_vi || "Something wrong",
        total_success: 0,
        total_failed: 0,
        failed_rows: [],
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    mutation,
    loading,
  };
};
